import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import Link for routing
import "./menu.css"; // Import custom CSS
import mainLogo from "../assets/logo.png"; // Corrected path

import Profile from "../components/users/Profile";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const Menu = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [open, setOpen] = useState(false);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
    setOpenSubMenu(null); // Close sub-menu when switching main menu
  };

  const toggleSubMenu = (submenu) => {
    setOpenSubMenu(openSubMenu === submenu ? null : submenu);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const docRef = doc(db, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUser(docSnap.data());
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const [user, setUser] = useState(null);
  return (
    <Navbar expand="lg" className="navbar-main">
      <Navbar.Brand href="/" className="d-flex align-items-center">
        <img
          src={mainLogo}
          alt="Logo"
          // className="logo-img"
          style={{ width: "80px", height: "80px", marginRight: "10px" }}
        />
      </Navbar.Brand>

      <Navbar.Toggle
        aria-controls="navbar-nav"
        onClick={() => setOpen(!open)}
      />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="ms-auto">
          {" "}
          {/* Bootstrap 5 uses ms-auto instead of ml-auto */}
          <Nav.Link as={Link} to="/">
            Home
          </Nav.Link>
          {user?.role === "admin" && (
            <NavDropdown
              title="Services"
              id="services-dropdown"
              show={openMenu === "services"}
              onClick={() => toggleMenu("services")}
              className="submenu-dropdown"
            >
              <NavDropdown.Item href="pc-cards">PC Cards</NavDropdown.Item>
              <NavDropdown.Item href="fsc-download">
                Download FSC
              </NavDropdown.Item>
              <NavDropdown.Item href="fsc-configur">
                FSC Download Configurer
              </NavDropdown.Item>
            </NavDropdown>
          )}
          <NavDropdown
            title="Company"
            id="company-dropdown"
            show={openMenu === "company"}
            onClick={() => toggleMenu("company")}
            className="submenu-dropdown"
          >
            <NavDropdown.Item as={Link} to="/about-us">
              About
            </NavDropdown.Item>
            <NavDropdown.Item>Case Study</NavDropdown.Item>
            <NavDropdown.Item>Resources</NavDropdown.Item>
            <NavDropdown.Item>Gallery</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link as={Link} to="/contact">
            Contact Us
          </Nav.Link>
          {/* <Nav className="ms-auto">
            {" "}
            {!user && (
              <Nav.Link as={Link} to="/register">
                Register{" "}
              </Nav.Link>
            )} */}
          {/* Other nav links */}
          {/* </Nav> */}
          {/* <Nav.Link as={Link} to="/login">
            Login
          </Nav.Link> */}
          {user ? (
            <Profile user={user} />
          ) : (
            <Nav.Link as={Link} to="/login">
              Login
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Menu;
